import { createAction } from 'redux-actions';
import {
    SET_PENDING_REQUEST,
    DELETE_ALL_PENDING_REQUESTS,
    DELETE_PENDING_REQUEST
} from './actionTypes';

// set a pending request
export const setPendingRequest = createAction(SET_PENDING_REQUEST)
export const deletePendingRequest = createAction(DELETE_PENDING_REQUEST);
export const deletePendingRequests = createAction(DELETE_ALL_PENDING_REQUESTS);

// Abort a specific pending request
export const abortPendingRequest = (reqId) => (dispatch, getState) => {
    const state = getState();
    const pendingRequests = state.requestsReducer.pendingRequests;

    const requestToAbort = pendingRequests[reqId];
    if (requestToAbort) {
        requestToAbort.abort();
        dispatch(deletePendingRequest({ id: reqId }));
    }
};

// Add pending request; a same-key request already in flight is aborted and
// replaced, so the new request stays trackable/abortable
export const addPendingRequest = ({ id, controller }) => (dispatch, getState) => {
    const state = getState();
    const pendingRequests = state.requestsReducer.pendingRequests;
    const request = pendingRequests[id];

    if (request) {
        dispatch(abortPendingRequest(id))
    }
    dispatch(setPendingRequest({ id, controller }))
}

// Delete a pending request only if the stored controller is still this
// request's own — a finished (or aborted) request must not remove the entry
// of a newer same-key request that replaced it
export const deletePendingRequestIfCurrent = ({ id, controller }) => (dispatch, getState) => {
    const pendingRequests = getState().requestsReducer.pendingRequests;
    if (pendingRequests[id] === controller) {
        dispatch(deletePendingRequest({ id }));
    }
};

// Abort all pending requests
export const abortPendingRequests = () => (dispatch, getState) => {
    const state = getState();
    const pendingRequests = state.requestsReducer.pendingRequests;

    for (const key in pendingRequests) {
        if (pendingRequests[key]) {
            pendingRequests[key].abort()
        }
    }
    dispatch(deletePendingRequests());
};